module.exports = __webpack_public_path__ + "img/order-list-icon.57c1a51.svg";